import React from "react";
import PropTypes from "prop-types";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const getSize = (size, height, width) => {
  if (size === "small") {
    return {
      height: "150px",
      width: "auto",
    };
  }
  return {
    height: height,
    width: width,
  };
};

const DotLotties = ({
  file,
  size,
  loop = true,
  height = "250px",
  width = "auto",
  autoplay = true,
}) => {
  const dimensions = getSize(size, height, width);

  return (
    <DotLottieReact
      src={file}
      loop={loop}
      autoplay={autoplay}
      style={{
        height: dimensions.height,
        width: dimensions.width,
      }}
    />
  );
};

DotLotties.propTypes = {
  file: PropTypes.any.isRequired, // URL or imported path to .lottie file
  size: PropTypes.string,
  loop: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  autoplay: PropTypes.bool,
};

export default DotLotties;
